import React, { useEffect, useState } from 'react'
import { useProfile } from './UserProfile/UserProfileProvider'
import { useApolloClient } from '@apollo/client'
import { GET_VENDOR } from '../Cases/Common/Queries'
import { useEnv } from '@praxis/component-runtime-env'
import { EnvConfig } from '../../config/appConfig'
import { Layout } from '@enterprise-ui/canvas-ui-react'

const VendorBannerLayout: React.FC = () => {
  const { userProfile } = useProfile()
  const client = useApolloClient()
  const env = useEnv() as EnvConfig
  const [importVendorFlag, setImportVendorFlag] = useState<boolean | null>(null)

  useEffect(() => {
    const fetchVendorFlag = async () => {
      if (userProfile?.defaultVendorId) {
        try {
          const { data } = await client.query({
            query: GET_VENDOR,
            variables: { id: userProfile.defaultVendorId },
            fetchPolicy: 'network-only',
          })
          const flag = data?.getVendor?.importVendorFlag === 'Y'
          setImportVendorFlag(flag)
        } catch (e) {
          setImportVendorFlag(null)
        }
      }
    }
    fetchVendorFlag()
  }, [userProfile?.defaultVendorId, client])

  if (!userProfile?.isVendor) return null
  if (importVendorFlag) return null

  const vendorExperienceUrl = env.vendorExperienceUrl

  return (
    <Layout.Notification type="alert">
      <span style={{ fontWeight: 700, marginRight: 8 }}>
        <a
          href={vendorExperienceUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: '#0056b3',
            textDecoration: 'underline',
            fontWeight: 700,
          }}
        >
          Click here
        </a>{' '}
        to access our NEW application designed to better support your dispute
        experience: Domestic Vendor Payments & Accounting.
      </span>
    </Layout.Notification>
  )
}

export default VendorBannerLayout
